var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkDesktopViews = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 10,
  viewBox: "0 0 14 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7 10c-4.2 0-7-4-7-5s2.8-5 7-5 7 4 7 5-2.8 5-7 5m0-1.5c1.9 0 3.5-1.6 3.5-3.5S8.9 1.5 7 1.5 3.5 3.1 3.5 5 5.1 8.5 7 8.5m0-1.9c-.9 0-1.6-.7-1.6-1.6S6.1 3.4 7 3.4s1.6.7 1.6 1.6S7.9 6.6 7 6.6"
})));
export default SvgVkDesktopViews;